module.exports = __webpack_public_path__ + "media/images/icon/payment/visa-b8947ca215d26a7249cffd9beaa65649.svg";